import {
  PushNotifications,
  PushNotificationSchema,
  Token,
  RegistrationError,
  // ActionPerformed,
} from '@capacitor/push-notifications'
import { renderNotification } from './render'
import { FeLogger } from '@/addons/monitoring'
import store from '@/store'
import { ConfigActions } from '@/store/configs-store'

const addListeners = async () => {
  await PushNotifications.addListener('registration', (token: Token) => {
    FeLogger.info(
      `[Push notifications mobile] Registration token: ${token.value}`,
    )
    // save token in vuex configs store
    store.dispatch(ConfigActions.SET_FCM_TOKEN, token.value).catch((e) => {
      FeLogger.error(
        '[Push notifications mobile] Failed to save FCM token in state',
        e,
      )
    })
  })

  await PushNotifications.addListener(
    'registrationError',
    (err: RegistrationError) => {
      FeLogger.error(`Registration error: ${err.error.toString()}`)
    },
  )

  await PushNotifications.addListener(
    'pushNotificationReceived',
    (notification: PushNotificationSchema) => {
      renderNotification(notification)
      // FeLogger.info(notification.title)
    },
  )

  await PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification) => {
      FeLogger.info(
        'Push notification action performed',
        notification.actionId,
        notification.inputValue,
      )
    },
  )
}

export const initMobilePushNotification = async () => {
  addListeners()
  let permStatus = await PushNotifications.checkPermissions()

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions()
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!')
  }

  await PushNotifications.register()
}
